// Reject delayed snapshots from a prior learner view. Subtract full measured
// request time conservatively; do not rely on the tablet's wall clock.
export function lessonSnapshotValidity(result,{instance,lessonId,session,phase},elapsedMs){
 const live=result?.live;
 const current=Boolean(live&&live.instance===instance
  &&Number(live.lessonId||0)===Number(lessonId||0)
  &&String(live.session||'')===String(session||'')
  &&live.phase===phase);
 const delay=Number.isFinite(elapsedMs)?Math.max(0,elapsedMs):Infinity;
 const remaining=deadline=>Number.isFinite(Number(deadline))&&Number.isFinite(Number(result?.serverNow))?Math.max(0,Number(deadline)-Number(result.serverNow)-delay):0;
 return {current,leaseMs:current&&live.teacherLed?remaining(live.leaseExpiresAt):0,commandMs:current&&result.command?remaining(result.command.expiresAt):0};
}
